module.exports = __webpack_public_path__ + "fonts/iconfont.6e0ca587.ttf";